import React from "react";
import InquiryContext from "@/utils/inquiry-context";
import allProducts from "@/data/products/products";
import { Menu, Transition } from "@headlessui/react";
import EditProduct from "./edit-product";
import { enqueueSnackbar, closeSnackbar } from "notistack";

const QuoteItems = () => {
  const { products, removeProduct } = React.useContext(InquiryContext);
  const [editingProduct, setEditingProduct] = React.useState(null);
  const [editDialogOpen, setEditDialogOpen] = React.useState(false);

  return (
    <div className="sm:card !overflow-visible">
      <div className="flex items-center justify-between rounded-t-md text-2xl text-auto-black/80 sm:bg-auto-black/10 sm:p-6">
        Quote Items
        <AddMoreItemsButton
          className="md:hidden"
          setEditDialogOpen={setEditDialogOpen}
          setEditingProduct={setEditingProduct}
        />
      </div>
      <div className="flex flex-col divide-auto-black/20 border-auto-black/40 p-0 sm:divide-y sm:border-t sm:p-0">
        <div className="hidden grid-cols-[125px_auto_72px_104px] divide-x-[1px] divide-auto-black/20 bg-auto-black/5 font-bold md:grid lg:grid-cols-[145px_auto_72px_104px]">
          <div className="px-6 py-4 text-auto-black/60">Item</div>
          <div className="px-6 py-4 text-auto-black/60">Description</div>
          <div className="px-6 py-4 text-auto-black/60"></div>
          <div className="px-6 py-4 text-auto-black/60"></div>
        </div>
        {products.map((product, index) => (
          <div
            key={index}
            className="max-sm:card my-2 !grid grid-cols-[auto_48px] gap-2 divide-auto-black/20 p-4 sm:my-0  sm:gap-0  sm:px-6 md:grid-cols-[125px_auto_72px_104px] md:divide-x-[1px] md:p-0 lg:grid-cols-[145px_auto_72px_104px]"
          >
            <div className="order-1 flex items-center justify-start font-semibold text-primary-800 md:px-6 md:py-2">
              {product.name}
            </div>
            <div className="order-2 flex items-center justify-end md:order-3 md:justify-center">
              <button
                type="button"
                className="button-icon text-red-500"
                onClick={() => {
                  const removedProduct = products.find(
                    (p) => p.code === product.code,
                  );
                  removeProduct(removedProduct);
                  enqueueSnackbar(
                    `${removedProduct.name} was removed from the quote.`,
                    {
                      variant: "info",
                      autoHideDuration: 7000,
                      anchorOrigin: {
                        vertical: "top",
                        horizontal: "center",
                      },
                      action: (snackbarId) => (
                        <RemoveItemSnackbarActions
                          snackbarId={snackbarId}
                          removedProduct={removedProduct}
                        />
                      ),
                    },
                  );
                }}
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g id="trash">
                    <path
                      id="Vector"
                      d="M20 9L18.005 20.3463C17.8369 21.3026 17.0062 22 16.0353 22H7.96474C6.99379 22 6.1631 21.3026 5.99496 20.3463L4 9"
                      stroke="#DC2626"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      id="Vector_2"
                      d="M21 6H15.375M3 6H8.625M8.625 6V4C8.625 2.89543 9.52043 2 10.625 2H13.375C14.4796 2 15.375 2.89543 15.375 4V6M8.625 6H15.375"
                      stroke="#DC2626"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </g>
                </svg>
              </button>
            </div>
            <div className="order-3 col-span-2 flex flex-wrap items-center justify-start text-auto-black/80 md:order-2 md:col-span-1 md:px-6 md:py-2">
              {Object.keys(product.options).map((option) => (
                <div className="">
                  <span key={option.title} className="font-bold">
                    {option}:&nbsp;
                  </span>
                  <span key={option.title} className="">
                    {product.options[option].join(", ")}&nbsp;&nbsp;&nbsp;
                  </span>
                </div>
              ))}
            </div>
            <div className="order-4 col-span-2 flex items-center justify-end md:col-span-1 md:justify-center">
              <button
                type="button"
                className="button-icon flex w-20 gap-2 pl-4 underline-offset-2 md:underline"
                onClick={() => {
                  const productToEdit = allProducts.find(
                    (p) => p.code === product.code,
                  );
                  setEditingProduct(productToEdit);
                  setEditDialogOpen(true);
                }}
              >
                Edit
                <svg
                  className="h-12 w-12 fill-none"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g id="edit-pencil">
                    <path
                      id="Vector"
                      d="M14.3632 5.65156L15.8431 4.17157C16.6242 3.39052 17.8905 3.39052 18.6716 4.17157L20.0858 5.58579C20.8668 6.36683 20.8668 7.63316 20.0858 8.41421L18.6058 9.8942M14.3632 5.65156L4.74749 15.2672C4.41542 15.5993 4.21079 16.0376 4.16947 16.5054L3.92738 19.2459C3.87261 19.8659 4.39148 20.3848 5.0115 20.33L7.75191 20.0879C8.21972 20.0466 8.65806 19.8419 8.99013 19.5099L18.6058 9.8942M14.3632 5.65156L18.6058 9.8942"
                      stroke="#3B82F6"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </g>
                </svg>
              </button>
            </div>
          </div>
        ))}
        <div className="hidden items-center justify-end p-4 md:flex">
          <AddMoreItemsButton
            setEditDialogOpen={setEditDialogOpen}
            setEditingProduct={setEditingProduct}
          />
        </div>
      </div>
      <EditProduct
        open={editDialogOpen}
        setOpen={setEditDialogOpen}
        product={editingProduct}
        showName
      />
    </div>
  );
};

export default QuoteItems;

const AddMoreItemsButton = ({
  className,
  setEditingProduct,
  setEditDialogOpen,
}) => {
  const { products, addProduct } = React.useContext(InquiryContext);

  const availableProducts = React.useMemo(
    () =>
      allProducts.filter(
        (product) => !products.some((p) => p.code === product.code),
      ),
    [products],
  );

  return (
    <Menu as="div" className="relative inline-block text-left">
      <div>
        <Menu.Button
          className={`button-transparent ${className}`}
          type="button"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="h-6 w-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 4.5v15m7.5-7.5h-15"
            />
          </svg>
          {/* {products.length > 0 ? "Add more items" : "Add items"} */}
          Add item
        </Menu.Button>
        <Transition
          as={React.Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items className="absolute right-0 z-50 w-56 divide-y divide-auto-black/5 rounded-md bg-card-background shadow-lg ring-1 ring-auto-black/5 focus:outline-none max-lg:top-14 max-lg:origin-top-right lg:bottom-14 lg:origin-bottom-right">
            {/* allProducts.filter((product) => !products.includes(product.code)) */}
            {availableProducts.length > 0 ? (
              <>
                {availableProducts.map((product) => (
                  <div className="px-1 py-1 ">
                    <Menu.Item>
                      {({ active }) => (
                        <button
                          type="button"
                          className={`${
                            active
                              ? "bg-blue-500 text-white"
                              : "text-auto-black/90"
                          } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                          onClick={() => {
                            addProduct({
                              code: product.code,
                              name: product.name,
                              options: {},
                            });
                            setEditingProduct(product);
                            setEditDialogOpen(true);
                          }}
                        >
                          {product.name}
                        </button>
                      )}
                    </Menu.Item>
                  </div>
                ))}
              </>
            ) : (
              <div className="flex h-12 items-center justify-start px-2 py-2 text-sm text-auto-black/60">
                <Menu.Item>
                  {({ active }) => <div>No more items to add</div>}
                </Menu.Item>
              </div>
            )}
          </Menu.Items>
        </Transition>
      </div>
    </Menu>
  );
};

const RemoveItemSnackbarActions = ({ snackbarId, removedProduct }) => {
  const { addProduct } = React.useContext(InquiryContext);
  return (
    <div className="flex gap-4 px-4">
      <button
        onClick={() => {
          // return the deleted product to the list
          addProduct(removedProduct);
          closeSnackbar(snackbarId);
        }}
      >
        Undo
      </button>
      <button
        onClick={() => {
          closeSnackbar(snackbarId);
        }}
      >
        Dismiss
      </button>
    </div>
  );
};
